import { GA_MEASUREMENT_ID } from '@/api/config';
import { makeAnalytics } from './analytics';
import { debugSink, fanOut, ga4Sink, loadGa4, noopSink } from './sink';

/**
 * Composition root: the sink is chosen once, here, and nothing downstream knows the vendor.
 *
 * Without a measurement id the whole thing is a no-op, so a developer without GA configured sees
 * nothing and breaks nothing. Dev builds fan out to the console as well, exactly like the app's
 * debug builds.
 */
function build() {
  if (!GA_MEASUREMENT_ID) return makeAnalytics(import.meta.env.DEV ? debugSink : noopSink);
  loadGa4(GA_MEASUREMENT_ID);
  const ga = ga4Sink(GA_MEASUREMENT_ID);
  return makeAnalytics(import.meta.env.DEV ? fanOut([debugSink, ga]) : ga);
}

export const analytics = build();

export { STEP, STEPS, BLOCKED, type BlockedReason, type Step } from './steps';
export { reportPageChange } from './analytics';
export { furthestStore } from './furthest';
